import { useMemo } from 'react';

import type { UnmatchedHolding } from '@/hooks/portfolio/usePortfolio';

import { sortValue } from './useSortedHoldings';

export const useSortedUnmatchedHoldings = (
  unmatchedHoldings: UnmatchedHolding[] = []
) => {
  return useMemo(() => {
    const sortingFn = (
      { symbol: a }: UnmatchedHolding,
      { symbol: b }: UnmatchedHolding
    ) => sortValue(a.toUpperCase(), b.toUpperCase(), 'asc');

    return [...unmatchedHoldings].sort(sortingFn);
  }, [unmatchedHoldings]);
};
